<div class="payee-big-switcher-wrapper" [style.--columns]="columns">
  <ng-content select="button[payee-big-switcher-button]"></ng-content>
</div>